/**
 * Ajax functions, used in Panel
 */

var AET_Ajax = function(){
    'use strict';

    var $ = jQuery; // enable jQuery
    var a_ajax = new AwesomeAjax('aetfree');
    var self = this;
    var prefix = 'aetfree';

    self.result = {};

    // load model to panel
    self.load_model = function(item_id, model_name){
        if($.isNumeric(item_id)){
            return a_ajax.load_model(
                model_name,
                item_id,
                function (data) {
                    window.model = new AwesomeModel(data); // set window model to Backbone model
                }
            );
        }
        if(item_id == '#'){
            if(model_name == 'group'){
                return a_ajax.ajax({
                    action: prefix + '_get_group_defaults',
                    success_handler: function (data) {
                        window.model = new AwesomeModel(data); // set window model to Backbone model
                    }
                });
            }
            if(model_name == 'testimonial'){
                return a_ajax.ajax({
                    action: prefix + '_get_testimonial_defaults',
                    success_handler: function (data) {
                        window.model = new AwesomeModel(data); // set window model to Backbone model
                    }
                });
            }
        }
    };

    self.fill_blocks_order = function (container, key, value) {
        var order = JSON.stringify(value);
        container.find('[name="group_' + key + '"]').val(order);
    };

    self.fill_group_styles_grid_blocks_order = self.fill_blocks_order.bind(self);
    self.fill_group_styles_table_blocks_order = self.fill_blocks_order.bind(self);

    // Fill group testimonials list (testimonial round avatars)
    self.fill_group_testimonials = function(container, key, testimonials){
        var html = '';
        var ids = [];
        $.each(testimonials, function(index, item){
            ids.push(item.ID);
            var foto = item.foto ? '<img width="40" height="40" src="' + item.foto + '">' : '<img src="' + window[prefix + '_localize']['default_avatar'] + '" alt="" />';
            var star = '<svg class="icon" viewBox="0 0 32 32"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#aet_icon-star-full"></use></svg>';
            var width = 'width:' + (16 * 5 * item.rating / 100) + 'px';

            var rating_html = '<div class="skill-value rating-format-5s" style="width: 80px;">';
            rating_html += '<div class="rating-bar rating-background">';
            for (var i = 0; i < 5; i++) {
                rating_html += star;
            }
            rating_html += '</div>';
            rating_html += '<div class="rating-bar rating-fill" style="' + width + '">';
            for (var j = 0; j < 5; j++) {
                rating_html += star;
            }
            rating_html += '</div>';
            rating_html += '</div>';

            /* jshint multistr: true */
            var template = _.template('\
                <li data-action="edit-testimonial" class="clearfix" testimonial-id="<%= ID %>" title="<%= name %>\n<%= short_text %>" post-status="<%= status %>">\
                    <div class="foto" data-wr_replaced="true">\
                        <%= foto %>\
                    </div>\
                    <div class="name_position">\
                        <span class="name"><%= name %></span>\
                        <span class="short_text"><%= short_text %></span>\
                        <span class="rating"><%= rating %></span>\
                    </div>\
                    <%  if(group_name) { %><div class="attached-to"><%= group_name %></div><% } %>\
                    <button class="btn-action remove-testimonial at-transition at-transition-fast" title="Remove" data-action="remove-testimonial">\
                        <svg viewBox="0 0 20 20">\
                            <use xlink:href="#icon-delete"></use>\
                        </svg>\
                    </button>\
                </li>');
            html += template({
                ID: item.ID,
                status: item.post_status,
                foto: foto,
                name: _.escape(item.post_title),
                short_text: _.escape(item.post_excerpt),
                rating: rating_html,
                groups_count: item.groups_count,
                group_name: item.group_name
            });
        });

        $(container).find('#group-testimonials').val(JSON.stringify(ids));
        $(container).find('#group-sortable').html('').append(html);
    };

    // fill colorpicker
    self.fill_color = function (container, key, value) {
        key = key.replace_all('group_', '');
        $(container).find('.' + key).find('input').val(value);
        $(container).find('.' + key).find('span.color > i').css('background-color', value);
    };

    // fill colorpickers
    self.fill_group_styles_button_color = self.fill_color.bind(self);
    self.fill_group_styles_button_hover_color = self.fill_color.bind(self);
    self.fill_group_styles_button_text_color = self.fill_color.bind(self);
    self.fill_group_styles_button_text_hover_color = self.fill_color.bind(self);
    self.fill_group_styles_base_color = self.fill_color.bind(self);
    self.fill_group_styles_card_base_color = self.fill_color.bind(self);
    self.fill_group_styles_card_border_color = self.fill_color.bind(self);
    self.fill_group_styles_card_divider_color = self.fill_color.bind(self);
    self.fill_group_styles_card_shadow_color = self.fill_color.bind(self);
    self.fill_group_styles_card_even_row_color = self.fill_color.bind(self);
    self.fill_group_panel_color = self.fill_color.bind(self);

    // fill blocks visibility
    self.fill_visibility = function(container, key, value){
        $(container).find('[name="' + key + '"]').attr('data-checked', value).val(value);
    };

    // fill group block visibility
    self.fill_group_styles_slider = self.fill_visibility.bind(self);
    self.fill_group_styles_slider_autoplay = self.fill_visibility.bind(self);
    self.fill_group_styles_slider_adaptive = self.fill_visibility.bind(self);
    self.fill_group_styles_filter = self.fill_visibility.bind(self);
    self.fill_group_panel_enabled = self.fill_visibility.bind(self);
    self.fill_group_panel_contacts_visible = self.fill_visibility.bind(self);
    self.fill_group_panel_social_visible = self.fill_visibility.bind(self);
    self.fill_group_panel_rating_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_reveal = self.fill_visibility.bind(self);
    self.fill_group_styles_bounce = self.fill_visibility.bind(self);
    self.fill_group_styles_body_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_photo_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_name_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_divider_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_position_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_short_text_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_short_text_body_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_short_text_nubbin_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_rating_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_social_visible = self.fill_visibility.bind(self);
    self.fill_group_styles_source_visible = self.fill_visibility.bind(self);

    // fill group blocks preview checkboxes
    self.fill_checkbox = function (container, key, value) {
        $(container).find('[name="' + key + '"]').attr('data-checked', value).val(value);
    };

    // fill group preview checkboxes (is_bold)
    self.fill_group_styles_filter_bold = self.fill_checkbox.bind(self);
    self.fill_group_styles_name_bold = self.fill_checkbox.bind(self);
    self.fill_group_styles_position_bold = self.fill_checkbox.bind(self);
    self.fill_group_styles_short_text_bold = self.fill_checkbox.bind(self);
    self.fill_group_styles_contacts_bold = self.fill_checkbox.bind(self);

    // fill group preview checkboxes (is_italic)
    self.fill_group_styles_filter_italic = self.fill_checkbox.bind(self);
    self.fill_group_styles_name_italic = self.fill_checkbox.bind(self);
    self.fill_group_styles_position_italic = self.fill_checkbox.bind(self);
    self.fill_group_styles_short_text_italic = self.fill_checkbox.bind(self);
    self.fill_group_styles_contacts_italic = self.fill_checkbox.bind(self);

    self.fill_select = function(container, key, value){
        $(container).find('[name="' + key + '"]').val(value);
        $(container).find('[name="' + key + '"]').dropdown('update');
    };

    // fill group layout select (formstone)
    self.fill_group_layout = self.fill_select.bind(self);
    self.fill_group_styles_hover = self.fill_select.bind(self);
    self.fill_group_panel_theme = self.fill_select.bind(self);

    // fill group template
    self.fill_group_template = function (container, key, value) {
        var html = '';
        var layout = window.model.get('layout');
        $.each(window.group_templates.get(layout), function(index, template){
            html += '<option value="' + index + '">' + template.label + '</option>';
        });
        $(container).find('[name="' + key + '"]').html('').html(html).val(value);
        $(container).find('[name="' + key + '"]').dropdown('update');
    };

    // fill testimonial photo
    self.fill_testimonial_foto = function(container, key, value){
        $('#testimonial-form-foto-remove', aet_panel).show();
        if(value === ''){
            $('#testimonial-form-foto-remove', aet_panel).hide();
        }
        var img = $('<img />').attr('src', value);
        $(container).find('#testimonial-form-foto').html('').append(img);
    };

    self.fill_testimonial_full_text = function(container, key, value) {
        window.testimonial_full_text_dfd = $.Deferred();
        a_ajax.ajax({
            action: prefix + '_get_tiny_mce',
            data: {
                id: key,
                content: value
            },
            success_handler: function (result) {
                $('.' + key, container).html(result);
                if(tinyMCE.get(key)){
                    tinyMCE.get(key).remove();
                }
                tinyMCEPreInit.mceInit[key].setup = function(editor) {
                    editor.on('init', function(e) {
                        testimonial_full_text_dfd.resolve('tinymce init');
                    });
                    editor.on('change', function (e) {
                        model.set('full_text', editor.getContent());
                    });
                    editor.on('PostRender')
                };
                tinyMCE.init(tinyMCEPreInit.mceInit[key]);
                try { quicktags( tinyMCEPreInit.qtInit[key] ); } catch(e){}
            }
        });
    };

    self.set_testimonial_photo = function (id, size, callback) {
        return a_ajax.ajax({
            action: prefix + '_get_group_preview_photo',
            data: {
                'id': id,
                'size': size,
            },
            success_handler: function (result) {
                var img = result !== '' ? result : '<img src="' + window[prefix + '_localize']['default_avatar'] + '"/>';
                callback(img);
            }
        });
    };

    self.set_group_testimonials = function (ids, size, callback) {
        return a_ajax.ajax({
            action: prefix + '_get_group_testimonials_photos',
            data: {
                'ids': ids,
                'size': size,
            },
            success_handler: function (result) {
                callback(result);
            }
        });
    };

    // get templates
    self.get_templates = function () {
        return a_ajax.ajax({
            action: prefix + '_get_templates',
            success_handler: function (result) {
                window.group_templates = new Backbone.NestedModel(result);
            }
        });
    };

    // init testimonial departmets
    self.init_categories = function () {
        return a_ajax.ajax({
            action: prefix + '_get_taxonomy_terms',
            data: {
                taxonomy: 'aet-testimonial-taxonomy'
            },
            success_handler: function (result) {
                window.aet_testimonials_taxonomy_terms = result;
            }
        });
    };
};